/* Mana Mātauranga · Sample 1 behaviour: menus, search, chooser, quick add-to-cart,
   EXAM10 countdown and scroll reveals. Everything uses event delegation so it keeps
   working when sections are edited in the theme editor. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const body = document.body;

  /* ---------- EXAM10: days left, and hide the offer once it ends ---------- */
  function promo() {
    const end = window.mmPromoEnd ? new Date(window.mmPromoEnd) : null;
    const live = end && !isNaN(end) && end > new Date();
    $$('[data-mm-promo]').forEach(el => { el.hidden = !live; });
    if (live) {
      const days = Math.max(1, Math.ceil((end - new Date()) / 86400000));
      $$('[data-mm-days-left]').forEach(el => { el.textContent = days + (days === 1 ? ' day' : ' days'); });
    }
  }

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(html) {
    let t = $('.mm-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mm-toast'; t.setAttribute('role', 'status'); body.appendChild(t); }
    t.innerHTML = html;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 4000);
  }

  /* ---------- menus ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-mm-menu-toggle]')) { body.classList.toggle('mm-menu-open'); return; }
    const ddBtn = t.closest('.mm-dd > button');
    if (ddBtn) {
      const dd = ddBtn.parentElement;
      const open = !dd.classList.contains('open');
      $$('.mm-dd.open').forEach(d => d.classList.remove('open'));
      dd.classList.toggle('open', open);
      ddBtn.setAttribute('aria-expanded', open);
      return;
    }
    if (!t.closest('.mm-dd')) $$('.mm-dd.open').forEach(d => d.classList.remove('open'));
    if (t.closest('.mm-mmenu a')) body.classList.remove('mm-menu-open');
  });

  /* ---------- search ---------- */
  const LINKS = [
    ['MM01 Quick Start Guide', 'Guide · set-up, modes, exam reset', '/pages/mm01-quick-start', 'manual manuals guide quick start instructions how help mm01'],
    ['Set up in 60 seconds', 'MM01 guide · MathI/MathO, degrees or radians', '/pages/mm01-quick-start#setup', 'setup set up settings mathio degrees radians angle contrast first'],
    ['The ten modes', 'MM01 guide · RUN, STAT, EQUA, GRAPH…', '/pages/mm01-quick-start#modes', 'modes menu run stat equa graph table matrix vector complex'],
    ['Clear the memory before an exam', 'MM01 guide · for NCEA externals', '/pages/mm01-quick-start#exam', 'exam reset clear memory supervisor assessment external initialize'],
    ['Error messages', 'MM01 guide · Math ERROR, Syntax ERROR…', '/pages/mm01-quick-start#errors', 'error errors syntax math stack cannot solve troubleshooting'],
    ['Algebra & equations', 'MM01 guide', '/pages/mm01-quick-start#algebra', 'algebra equation equations solve simultaneous polynomial roots'],
    ['Graphs & tables', 'MM01 guide', '/pages/mm01-quick-start#graphs', 'graph graphs table tables plot intercept g-solve'],
    ['Calculus', 'MM01 guide', '/pages/mm01-quick-start#calculus', 'calculus differentiate integrate derivative integral'],
    ['Probability distributions', 'MM01 guide', '/pages/mm01-quick-start#dist', 'distribution distributions normal binomial poisson probability stats statistics'],
    ['Which calculator do I need?', '30-second helper', '/#chooser', 'which need compare difference graphing scientific choose'],
    ['For Schools', 'Bulk pricing & invoice ordering', '/pages/for-schools', 'school schools bulk class set invoice purchase order department teacher quote'],
    ['Contact & order tracking', 'Email, phone, tracking', '/pages/contact-us', 'contact email phone call tracking order orders help'],
    ['MM82 Plus Quick Start Guide', 'Guide · fractions, trig, statistics', '/pages/mm82-plus-quick-start', 'mm82 plus manual manuals guide quick start instructions how scientific setup reset'],
    ['Fractions & percentages', 'MM82 Plus guide · S⇔D, mixed numbers, GST', '/pages/mm82-plus-quick-start#fractions', 'fraction fractions mixed decimal percent percentage gst sd'],
    ['Statistics on the MM82 Plus', 'MM82 Plus guide · mean, standard deviation', '/pages/mm82-plus-quick-start#stats', 'mean average standard deviation stats statistics regression data mm82'],
    ['MM-991ES Quick Start Guide', 'Guide · equations, calculus, matrices', '/pages/mm-991es-quick-start', '991 991es mm-991es manual manuals guide quick start instructions advanced'],
    ['Equations & SOLVE', 'MM-991ES guide · simultaneous, quadratic, cubic', '/pages/mm-991es-quick-start#equations', 'equation equations simultaneous quadratic cubic solve eqn 991'],
    ['Calculus on the MM-991ES', 'MM-991ES guide · integrate, differentiate, sum', '/pages/mm-991es-quick-start#calculus', 'integrate integration differentiate derivative sum sigma 991'],
    ['Matrices & vectors', 'MM-991ES guide', '/pages/mm-991es-quick-start#matrices', 'matrix matrices determinant inverse vector vectors dot 991'],
  ];
  window.mmHelpLinks = LINKS; // the chat helper (mm-s1-pages.js) uses the same guide index
  const POPULAR = [0, 3, 9, 10];
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  let products = [];
  try { const el = $('#mm-search-products'); if (el) products = JSON.parse(el.textContent); } catch (err) { /* ignore */ }

  function item(title, sub, url, img) {
    return `<a class="mm-sr-item" href="${esc(url)}">${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : ''}<span><b>${esc(title)}</b><span>${esc(sub)}</span></span></a>`;
  }
  function localMatches(q) {
    const words = q.toLowerCase().split(/\s+/).filter(Boolean);
    return LINKS.map(r => {
      const hay = (r[0] + ' ' + r[1] + ' ' + r[3]).toLowerCase();
      const score = words.reduce((s, w) => s + (hay.includes(w) ? (r[0].toLowerCase().includes(w) ? 3 : 1) : -9), 0);
      return [score, r];
    }).filter(x => x[0] > 0).sort((a, b) => b[0] - a[0]).map(x => x[1]);
  }
  let searchSeq = 0;
  async function runSearch(q) {
    const res = $('[data-mm-search-results]');
    if (!res) return;
    q = q.trim();
    if (!q) {
      res.innerHTML = '<p class="mm-sr-head">Calculators</p>' + products.map(p => item(p.title, p.sub, p.url, p.img)).join('') +
        '<p class="mm-sr-head">Popular help</p>' + POPULAR.map(i => item(LINKS[i][0], LINKS[i][1], LINKS[i][2])).join('');
      return;
    }
    const seq = ++searchSeq;
    const local = localMatches(q);
    let found = [], pages = [];
    try {
      const url = `${(window.routes && window.routes.predictive_search_url) || '/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product,page&resources[limit]=6`;
      const data = await (await fetch(url)).json();
      found = (data.resources.results.products || []).map(p => item(p.title, '$' + Number(p.price).toFixed(2), p.url, p.image));
      pages = (data.resources.results.pages || []).filter(p => !local.some(l => l[2].split('#')[0] === p.url.split('?')[0])).map(p => item(p.title, 'Page', p.url));
    } catch (err) { /* offline or blocked: local results still show */ }
    if (seq !== searchSeq) return;
    const help = local.slice(0, 6).map(r => item(r[0], r[1], r[2])).concat(pages);
    let html = '';
    if (found.length) html += '<p class="mm-sr-head">Calculators</p>' + found.join('');
    if (help.length) html += '<p class="mm-sr-head">Help &amp; guides</p>' + help.join('');
    if (!html) html = `<p class="mm-sr-none">Nothing for “${esc(q)}”. <a href="/pages/contact-us">Ask us instead</a>, we're happy to help.</p>`;
    html += `<a class="mm-sr-all" href="/search?q=${encodeURIComponent(q)}">See all results for “${esc(q)}” →</a>`;
    res.innerHTML = html;
  }
  let searchTimer;
  function openSearch() {
    body.classList.remove('mm-menu-open');
    body.classList.add('mm-search-open');
    const i = $('[data-mm-search-input]');
    if (i) { i.value = ''; runSearch(''); setTimeout(() => i.focus(), 40); }
  }
  function closeSearch() { body.classList.remove('mm-search-open'); }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-mm-open-search]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-mm-close-search]')) closeSearch();
  });
  document.addEventListener('input', e => {
    if (e.target.matches('[data-mm-search-input]')) {
      clearTimeout(searchTimer);
      const v = e.target.value;
      searchTimer = setTimeout(() => runSearch(v), 180);
    }
  });
  document.addEventListener('keydown', e => {
    const typing = /input|textarea|select/i.test(document.activeElement.tagName) || document.activeElement.isContentEditable;
    if (e.key === '/' && !typing && $('[data-mm-search-input]')) { e.preventDefault(); openSearch(); }
    if (e.key === 'Escape') { closeSearch(); body.classList.remove('mm-menu-open'); $$('.mm-dd.open').forEach(d => d.classList.remove('open')); }
    if (e.key === 'Enter' && e.target.matches('[data-mm-search-input]')) {
      const first = $('[data-mm-search-results] .mm-sr-item');
      const q = e.target.value.trim();
      if (q) { e.preventDefault(); window.location.href = first ? first.href : '/search?q=' + encodeURIComponent(q); }
    }
  });

  /* ---------- quick add-to-cart (stays on the page) ---------- */
  async function refreshCount() {
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      $$('[data-mm-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('has', cart.item_count > 0); });
    } catch (err) { /* ignore */ }
  }
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form.mm-add-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type=submit]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add');
      await refreshCount();
      // the cart drawer (mm-s1-shop.js) takes over if it's on the page; otherwise show a small message
      const shown = !document.dispatchEvent(new CustomEvent('mm:added', { cancelable: true, detail: data }));
      if (!shown) toast(`<span><b>${esc(data.product_title || 'Added')}</b> is in your cart</span><a href="/cart">View cart →</a>`);
    } catch (err) {
      toast(`<span>${esc(err.message)}</span>`);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  });

  /* ---------- "which one do I need?" ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-mm-pick]');
    if (!b) return;
    const ch = b.closest('[data-mm-chooser]');
    $$('[data-mm-pick]', ch).forEach(x => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
    $$('[data-mm-pick-result]', ch).forEach(r => { r.hidden = r.dataset.mmPickResult !== b.dataset.mmPick; });
    const hint = $('[data-mm-pick-hint]', ch);
    if (hint) hint.hidden = true;
  });

  /* ---------- scroll reveal + header shadow ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { threshold: 0.12 })
    : null;
  function reveal(root) { $$('.mm-reveal:not(.in)', root).forEach(el => { if (io) io.observe(el); else el.classList.add('in'); }); }
  window.addEventListener('scroll', () => body.classList.toggle('mm-scrolled', window.scrollY > 8), { passive: true });

  function init(root) { promo(); reveal(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
